import Vue from 'vue'
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import DualListSelector from './views/envios/components/dualListSelector'
import router from './router'
import store from './store'
import App from './App'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/bootstrap'
import '@/libs/vee-validate'
import '@/libs/ripple'
import '@/libs/cleave'
import '@/libs/flat-pickr'
import '@/libs/firebase'
import '@/libs/vue-autosuggest'
import '@/libs/app-colapse'
// Axios Mock Adapter

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  DualListSelector,
  render: h => h(App),
}).$mount('#app')
